import type { StyleRule } from '@archipro-design/aria';
import {
    dividerClassName,
    getScrollbarStyle,
    pxToRem,
    DESKTOP_TOP_NAV_HEIGHT_WITH_SECOND_NAV,
    MOBILE_TOP_NAV_HEIGHT_FULL_LOGO,
} from '@archipro-design/aria';

export const ProductSearchModal: StyleRule = ({ theme }) => ({
    height: pxToRem(611),
    width: pxToRem(360),
    backgroundColor: theme.siteVariables.colors.white['100A'],
    boxShadow: '0px 14px 24px 2px rgba(0, 0, 0, 0.08)',
});

export const ModalFooter: StyleRule = ({ theme }) => ({
    padding: pxToRem(16),
    position: 'absolute',
    width: '100%',
    bottom: 0,
    left: 0,
    backgroundColor: theme.siteVariables.colors.primitive.white,
    borderTop: `1px solid ${theme.siteVariables.colors.white['300']}`,
});

export const SearchField: StyleRule = ({ theme }) => ({
    padding: pxToRem(16),
    scrollMarginTop: pxToRem(MOBILE_TOP_NAV_HEIGHT_FULL_LOGO),
    [theme.screen.laptop]: {
        scrollMarginTop: pxToRem(DESKTOP_TOP_NAV_HEIGHT_WITH_SECOND_NAV),
    },
});

export const SearchTextInput: StyleRule = () => ({
    '& svg': {
        height: pxToRem(26),
        width: pxToRem(26),
    },

    [`& .${dividerClassName}::before`]: {
        height: pxToRem(2),
    },
});

export const SearchBody: StyleRule = ({ theme }) => ({
    paddingLeft: pxToRem(8),
    maxHeight: pxToRem(454),
    overflow: 'none',
    overflowY: 'auto',
    ...getScrollbarStyle(theme, '0'),
});

export const SearchLoading: StyleRule = () => ({
    width: '100%',
    height: '100%',
    background: `rgba(0,0,0,0.3)`,
    position: 'absolute',
    top: 0,
    lefT: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

export const Loader: StyleRule = ({ theme }) => ({
    height: pxToRem(108),
    width: pxToRem(108),
    '& svg': {
        fill: theme.siteVariables.colors.primitive.white,
    },
});

export const EmptyResults: StyleRule = () => ({
    marginLeft: pxToRem(8),
});

export const ContentWrapper: StyleRule = () => ({
    height: pxToRem(552),
});
